module.exports = __webpack_public_path__ + "static/media/md-play.81c9de12.svg";